import { useContext } from 'react'
import { toast } from 'react-toastify'

import { useRealtimeSubscription, useSetState, useUniqueId } from '@domain-group/react-hooks'

import { digObject } from '@domain-group/javascript-utils'

import RealtimeContext from '@contexts/realtimeContext'

import useCampaign from '@hooks/useCampaign'

type AblyPayload = {
  payload: {
    data: object[],
    errors?: string[],
    success: boolean,
  },
}

const processingComplete = (data: AblyPayload): void => {
  const success = digObject(data, 'payload.success', false)
  const resultData = digObject(data, 'payload.data', [])
  const errors = digObject(data, 'payload.errors', [])

  if (success) toast(`${resultData.length} Campaigns Remapped Successfully`)
  if (!success) toast(errors[0])
}

const defaultState = {
  fileData: '',
}

type Options = {
  callbacks: {
    closeModal: () => void,
  },
}

function useBulkRemapCampaignPortalsModal(options: Options) {
  const { callbacks } = options
  const { closeModal } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { fileData } = state

  const [uuid] = useUniqueId({ persistKey: window.location.pathname })

  const realtimeContext = useContext(RealtimeContext)
  // @ts-expect-error TS2339
  const { clientRef } = realtimeContext

  // Realtime/Websocket Connection
  useRealtimeSubscription({
    apiKey: process.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (data: AblyPayload) => processingComplete(data),
    },
    channelName: 'campaigns',
    clientRef,
    eventName: `campaign.${uuid}.portal_remap.complete`,
  }, [uuid])

  const campaignPayload = useCampaign()
  const {
    callbacks: { bulkPortalRemap },
    updating,
  } = campaignPayload

  const bulkRemapPayload = {
    callbacks: {
      action: bulkPortalRemap,
      afterAction: closeModal,
    },
    entityParams: fileData,
    requestOptions: {
      broadcast_complete: true,
      commit: true,
      key: uuid,
    },
    toastText: 'Portal Remapping Queued',
  }

  return {
    bulkRemapPayload,
    callbacks: {
      bulkPortalRemap,
      setState,
    },
    fileData,
    updating,
  }
}

export default useBulkRemapCampaignPortalsModal
